export const HOME_ROUTE = '-';
export const ERROR_ROUTE = 'error';
export const BATCH_SIZE = 100;
export const LOOKUPS_DEBOUNCE = 250;
export const LISTS_DEBOUNCE = 250;
export const INLINE_SEPARATOR = '&nbsp;&nbsp;&nbsp;';
export const VALIDATION_MESSAGES_LIMIT = 3;
export const PHONE_REGEX = /^(((((\+)|(00))[1-9][0-9]{0,2})( )?))[1-9][0-9 ]{5,}$/;
export const MAX_DATE = new Date(2100, 0, 1);
